<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-switch`]" width="1em" height="1em" v-bind="$attrs"><rect x="1.409" y="3.498" width="21.182" height="17.004" rx="8.502" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><rect x="10.895" y="8.016" width="7.968" height="7.968" rx="3.984" stroke="#00BBD8" stroke-width="1.66" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorSwitch',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
